import { App } from 'antd';
import { useMemo } from 'react';

interface IReactionConfirmOptions {
  title?: string;
  content?: string;
  okText?: string;
  cancelText?: string;
}

/**
 * Helpers exposed to schema `x-reactions` scripts through the SchemaField scope.
 * `$confirm` opens the app's confirm modal and resolves to the user's choice.
 */
export const useReactionScope = () => {
  const { modal } = App.useApp();

  return useMemo(
    () => ({
      $confirm: (options: IReactionConfirmOptions = {}) =>
        new Promise<boolean>(resolve => {
          modal.confirm({
            ...options,
            onOk: () => resolve(true),
            onCancel: () => resolve(false),
          });
        }),
    }),
    [modal]
  );
};
